import { StripeConnectedAccountModel } from '@modules/stripe/stripe-connected-account/stripe-connected-account-model';

const { fields } = StripeConnectedAccountModel;

export default [
  fields.id,

  fields.createdAt
];
